import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import useCartTimers from '../../../hooks/useCartTimers';
import { appEnv } from '../../../utils/env';
import * as styles from './UpgradeDisclaimer.module.scss';

const UpgradeDisclaimer = () => {
  const { loadingCartTimers, cartUpgradeResult } = useCartTimers();
  const cartUpgradeDisclaimerName =
    cartUpgradeResult === 'maintained'
      ? DISCLAIMER_NAMES.upgradeCartMaintained
      : cartUpgradeResult === 'dumped' || cartUpgradeResult === 'shelved'
        ? DISCLAIMER_NAMES.upgradeCartDumped
        : null;
  return (
    <div className={styles.upgradeDisclaimerContainer}>
      <Disclaimer name={DISCLAIMER_NAMES.upgradeToday} env={appEnv} />
      {!loadingCartTimers && cartUpgradeDisclaimerName && (
        <div className={styles.upgradeCartDisclaimer}>
          <Disclaimer name={cartUpgradeDisclaimerName} env={appEnv} />
        </div>
      )}
    </div>
  );
};

export default UpgradeDisclaimer;
